export default __webpack_public_path__ + "static/19-51397334f4135f3b2d12870f27355c9b.jpg";